module.exports = __webpack_public_path__ + "img/soundcloud.08a39c41.png";